import styled from '@emotion/styled';

export const BaseBadge = styled.div<{ isDraft?: boolean }>`
    align-items: center;
    background-color: ${({ isDraft, theme }) => (isDraft ? theme.colors.black[50] : theme.colors.secondary[900])};
    border-radius: 4px;
    bottom: 12px;
    color: ${({ isDraft, theme }) => (isDraft ? theme.colors.black[550] : theme.colors.white)};
    display: flex;
    font-size: 12px;
    font-weight: 500;
    height: 19px;
    justify-content: center;
    left: 12px;
    letter-spacing: -0.24px;
    padding: 0 1rem;
    position: absolute;
    z-index: 2;

    svg {
        margin-right: 4px;
    }
`;
